module.exports = __webpack_public_path__ + "static/sprite-1ef957073e678370898bb9aae7c773d4.png";